<template>
    <div id="footer">
        <div class="container-fluid">
            <div class="footer-container container">
                <div class="footer-box row">
                    <div class=" col-xs-12 col-sm-4 col-md-4">
                        <div class="foot-logo">
                            <img src="@/assets/img/logo.png" alt="">
                            <p>壹康科技</p>
                        </div>
                        <div class="company-info">地址：中国山东省青岛市高新区汇智桥路151号</div>
                        <div class="company-info">电话：0532-xxxxxx</div>
                        <div class="company-info">邮箱：xxxx@xxxxxxx.COM</div>
                    </div>
                    <div class=" col-xs-12 col-sm-4 col-md-5 foot-column-center">
                        <div class="column-box">
<!--                            <div class="column-list">
                                <div class="column-list-title"><a href="#">解决方案</a></div>
                                <div class="column-list-item"><a href="#">家庭解决方案</a></div>
                                <div class="column-list-item"><a href="#">家庭解决方案</a></div>
                                <div class="column-list-item"><a href="#">家庭解决方案</a></div>
                            </div>-->
                            <div class="column-list">
                                <div class="column-list-title"><router-link to="/ServiceDetail">项目精典</router-link></div>
                                <div class="column-list-item"><router-link to="/ServiceDetail">互联网+慢病续方平台</router-link></div>
                                <div class="column-list-item"><router-link to="/ServiceDetail">‘‘紧密型’’医联体服务模式</router-link></div>
                                <div class="column-list-item"><router-link to="/ServiceDetail">院内就诊流程‘‘深度优化’’</router-link></div>
                            </div>
                            <div class="column-list">
                                <div class="column-list-title">快捷栏目</div>
                                <div class="column-list-item"><router-link to="/software/smartTown">产品介绍</router-link></div>
                                <div class="column-list-item"><router-link to="/ServiceDetail">项目案例</router-link></div>
                                <div class="column-list-item"><router-link to="/companyintroduction">申请试用</router-link></div>
                            </div>
                        </div>
                    </div>
                    <div class=" col-xs-12 col-sm-4 col-md-3">
                        <div class="qrcode-title">官方微信</div>
                        <div class="qrcode-img">
                            <img class="qrcode-img" src="@/assets/img/qrcode.jpg" alt="">
                        </div>
                    </div>
                  <div class="col-xs-12 col-sm-12 m-copy">
                    <div>Copyright &copy; 壹康科技（青岛）有限公司版权所有</div>
                    <div class="mt10">
                      <a class="gov-icp-link" href="https://beian.miit.gov.cn/#/Integrated/index" rel="noreferre" target="_blank">鲁ICP备2024080335号-1</a>
                    </div>
                    <div class="mt10">
                        <img class="gov-mps-img" src="static/备案图标.png">
                        <a class="gov-mps-link" href="https://beian.mps.gov.cn/#/query/webSearch?code=37020002000367" rel="noreferre" target="_blank">鲁公网安备37020002000367</a>
                      </div>
                  </div>
                </div>
            </div>
        </div>
        <div class="container-fluid" id="footer-copy">
            <div class="footer-bottom">
                <div class="container">
                    <div class="copy">
                      <div>Copyright &copy; 壹康科技（青岛）有限公司版权所有
                        <a href="https://beian.miit.gov.cn/" rel="noreferrer" target="_blank">鲁ICP备2024080335号-1</a>
                      </div>
                      <div>
                        <img class="gov-mps-img" src="static/备案图标.png">
                        <a class="gov-mps-link" href="https://beian.mps.gov.cn/#/query/webSearch?code=37020002000367" rel="noreferre" target="_blank">鲁公网安备37020002000367</a>
                     </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
}
.footer-box{
    margin: 30px 0;
}
.foot-logo{
    display: flex;
    align-items: center;
}
.foot-logo img{
    margin-right: 20px;
    width: 75px;
    height: 50px;
}
.foot-logo p{
    margin-bottom: 0;
    font-size: 24px;
}
.company-info{
    margin-top: 25px;
    font-size: 14px;
    color:#949494;
}
.footer-bottom{
    margin: 0 -15px;
    background: #252525;
    height: 120px;
    line-height: 40px;
}
.qrcode-title{
    padding-top: 20px;
    padding-bottom: 20px;
    font-size: 16px;
    color:#ffffff;
    padding-left: 60px;
}
.qrcode-img{
    margin: auto;
    width: 110px;
    height: 110px;
}
.column-box{
    display: flex;
    flex-flow: row;
}
.column-list{
    display: flex;
    flex-flow: column;
    flex: 1 1;
    overflow: hidden;
}
.column-list-title{
    padding-top: 20px;
    font-size: 16px;
    color: #fff;
    padding-bottom: 50px;
    height: 22px;
    line-height: 22px;
    max-width: 150px;
}
.column-list-title a{
    color: #fff;
}
.column-list-item{
    height: 36px;
    line-height: 36px;
    font-size: 14px;
    color: #999999;
}
.column-list-item a{
    color: #999999;
}

.copy {
  margin-bottom: 5px;
  color: #d3d3d3;
  font-size: 14px;
  text-align: center;
}
.m-copy{
  text-align: center;
  display: none;
}
.mt10{
  margin-top:10px;
}
.gov-mps-img{
  display: inline-block;height:16px;margin-top: -3px;
}
.gov-mps-link{
  margin-left:5px;color: unset;
}
.gov-icp-link{
  color: unset;
}
/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
  .foot-logo,.foot-column-center,.qrcode-title,#footer-copy{
    display: none;
  }
  .company-info,.qrcode-img{
    margin-top: 10px;
  }
  .m-copy{
    display: block;
    margin-top: 20px;
    color: #949494;
  }
  .footer-container.container{
    padding: 0;
  }
}
/* 媒体查询（平板） */
@media screen and (min-width: 768px) and (max-width: 996px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 0 0 10px;
}

}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue